const e = "0.3", n = "0.4", r = 0.08, t = 0.12, o = 0.04, c = {
  1: 0.05,
  2: 0.08,
  3: 0.11
}, a = {
  primary: "#0089FD",
  success: "#009968",
  warning: "#FFB025",
  error: "#EC0052",
  premium: "#8759EE"
}, i = {
  primary: "#8759EE",
  success: "#009968",
  warning: "#FFB025",
  error: "#EC0052",
  premium: "#8759EE"
}, u = {
  primary: "#9649FF",
  success: "#009968",
  warning: "#FFB025",
  error: "#EC0052",
  premium: "#8759EE"
}, m = {
  primary: "#0B2FAC",
  success: "#4A9A6F",
  warning: "#E8A000",
  error: "#CC2F1F",
  premium: "#5F48D3"
}, l = 16, s = "#777777", g = {
  magenta: "#CC71C4",
  violet: "#8565D1",
  blue: "#7E8AE0",
  azure: "#3599D1",
  cyan: "#00A1A4",
  green: "#3DA26E",
  chartreuse: "#889930",
  yellow: "#BD8713",
  orange: "#D8764A",
  pink: "#DE687E"
}, h = {
  "primary-high-surface": ["primary", "60"],
  "primary-medium-surface": ["primary", "90"],
  "primary-low-surface": ["primary", "95"],
  "success-high-surface": ["success", "60"],
  "success-medium-surface": ["success", "90"],
  "success-low-surface": ["success", "95"],
  "warning-high-surface": ["warning", "60"],
  "warning-medium-surface": ["warning", "90"],
  "warning-low-surface": ["warning", "95"],
  "error-high-surface": ["error", "60"],
  "error-medium-surface": ["error", "90"],
  "error-low-surface": ["error", "95"],
  "premium-high-surface": ["premium", "60"],
  "premium-medium-surface": ["premium", "90"],
  "premium-low-surface": ["premium", "95"],
  "neutral-high-surface": ["neutral", "60"],
  "neutral-medium-surface": ["neutralMono", "90"],
  "neutral-low-surface": ["neutralMono", "95"],
  "background-base": ["neutral", "100"],
  "background-overlay": ["primary", "50"],
  foreground: ["neutral", "100"],
  "foreground-variant-overlay": ["neutral", "50"],
  "hover-and-active-overlay": ["neutral", "40"],
  "primary-high-content": ["primary", "50"],
  "primary-medium-content": ["primary", "70"],
  "primary-low-content": ["primary", "80"],
  "primary-xLow-content": ["primary", "90"],
  "contentOn-primary-high-surface": ["primary", "100"],
  "success-high-content": ["success", "50"],
  "success-medium-content": ["success", "70"],
  "success-low-content": ["success", "80"],
  "success-xLow-content": ["success", "90"],
  "contentOn-success-high-surface": ["success", "100"],
  "warning-high-content": ["warning", "50"],
  "warning-medium-content": ["warning", "70"],
  "warning-low-content": ["warning", "80"],
  "warning-xLow-content": ["warning", "90"],
  "contentOn-warning-high-surface": ["warning", "100"],
  "error-high-content": ["error", "50"],
  "error-medium-content": ["error", "70"],
  "error-low-content": ["error", "80"],
  "error-xLow-content": ["error", "90"],
  "contentOn-error-high-surface": ["error", "100"],
  "premium-high-content": ["premium", "50"],
  "premium-medium-content": ["premium", "70"],
  "premium-low-content": ["premium", "80"],
  "premium-xLow-content": ["premium", "90"],
  "contentOn-premium-high-surface": ["premium", "100"],
  "neutral-high-content": ["neutral", "40"],
  "neutral-medium-content": ["neutral", "60"],
  "neutral-low-content": ["neutral", "80"],
  "neutral-xLow-content": ["neutralMono", "90"],
  "contentOn-neutral-high-surface": ["neutral", "100"],
  "magenta-high-content": ["magenta", "50"],
  "magenta-medium-content": ["magenta", "70"],
  "magenta-low-content": ["magenta", "80"],
  "magenta-xLow-content": ["magenta", "90"],
  "violet-high-content": ["violet", "50"],
  "violet-medium-content": ["violet", "70"],
  "violet-low-content": ["violet", "80"],
  "violet-xLow-content": ["violet", "90"],
  "blue-high-content": ["blue", "50"],
  "blue-medium-content": ["blue", "70"],
  "blue-low-content": ["blue", "80"],
  "blue-xLow-content": ["blue", "90"],
  "azure-high-content": ["azure", "50"],
  "azure-medium-content": ["azure", "70"],
  "azure-low-content": ["azure", "80"],
  "azure-xLow-content": ["azure", "90"],
  "cyan-high-content": ["cyan", "50"],
  "cyan-medium-content": ["cyan", "70"],
  "cyan-low-content": ["cyan", "80"],
  "cyan-xLow-content": ["cyan", "90"],
  "green-high-content": ["green", "50"],
  "green-medium-content": ["green", "70"],
  "green-low-content": ["green", "80"],
  "green-xLow-content": ["green", "90"],
  "chartreuse-high-content": ["chartreuse", "50"],
  "chartreuse-medium-content": ["chartreuse", "70"],
  "chartreuse-low-content": ["chartreuse", "80"],
  "chartreuse-xLow-content": ["chartreuse", "90"],
  "yellow-high-content": ["yellow", "50"],
  "yellow-medium-content": ["yellow", "70"],
  "yellow-low-content": ["yellow", "80"],
  "yellow-xLow-content": ["yellow", "90"],
  "orange-high-content": ["orange", "50"],
  "orange-medium-content": ["orange", "70"],
  "orange-low-content": ["orange", "80"],
  "orange-xLow-content": ["orange", "90"],
  "pink-high-content": ["pink", "50"],
  "pink-medium-content": ["pink", "70"],
  "pink-low-content": ["pink", "80"],
  "pink-xLow-content": ["pink", "90"],
  "magenta-utility": ["magenta", "60"],
  "violet-utility": ["violet", "60"],
  "blue-utility": ["blue", "60"],
  "azure-utility": ["azure", "60"],
  "cyan-utility": ["cyan", "60"],
  "green-utility": ["green", "60"],
  "chartreuse-utility": ["chartreuse", "60"],
  "yellow-utility": ["yellow", "60"],
  "orange-utility": ["orange", "60"],
  "pink-utility": ["pink", "60"],
  shadow: ["primary", "60"],
  "modal-overlay": ["neutral", "10"],
  white: ["neutral", "100"],
  logo: ["primary", "50"]
}, w = {
  "primary-high-surface": ["primary", "60"],
  "primary-medium-surface": ["primary", "30"],
  "primary-low-surface": ["primary", "10"],
  "success-high-surface": ["success", "60"],
  "success-medium-surface": ["success", "30"],
  "success-low-surface": ["success", "10"],
  "warning-high-surface": ["warning", "60"],
  "warning-medium-surface": ["warning", "30"],
  "warning-low-surface": ["warning", "10"],
  "error-high-surface": ["error", "60"],
  "error-medium-surface": ["error", "30"],
  "error-low-surface": ["error", "10"],
  "premium-high-surface": ["premium", "60"],
  "premium-medium-surface": ["premium", "30"],
  "premium-low-surface": ["premium", "10"],
  "neutral-high-surface": ["neutral", "60"],
  "neutral-medium-surface": ["neutral", "30"],
  "neutral-low-surface": ["neutral", "10"],
  "background-base": ["neutral", "14"],
  "background-overlay": ["neutral", "14"],
  foreground: ["neutral", "20"],
  "foreground-variant-overlay": ["neutral", "100"],
  "hover-and-active-overlay": ["neutral", "100"],
  "primary-high-content": ["primary", "70"],
  "primary-medium-content": ["primary", "50"],
  "primary-low-content": ["primary", "40"],
  "primary-xLow-content": ["primary", "30"],
  "contentOn-primary-high-surface": ["primary", "20"],
  "success-high-content": ["success", "70"],
  "success-medium-content": ["success", "50"],
  "success-low-content": ["success", "40"],
  "success-xLow-content": ["success", "30"],
  "contentOn-success-high-surface": ["success", "20"],
  "warning-high-content": ["warning", "70"],
  "warning-medium-content": ["warning", "50"],
  "warning-low-content": ["warning", "40"],
  "warning-xLow-content": ["warning", "30"],
  "contentOn-warning-high-surface": ["warning", "20"],
  "error-high-content": ["error", "70"],
  "error-medium-content": ["error", "50"],
  "error-low-content": ["error", "40"],
  "error-xLow-content": ["error", "30"],
  "contentOn-error-high-surface": ["error", "20"],
  "premium-high-content": ["premium", "70"],
  "premium-medium-content": ["premium", "50"],
  "premium-low-content": ["premium", "40"],
  "premium-xLow-content": ["premium", "30"],
  "contentOn-premium-high-surface": ["premium", "20"],
  "neutral-high-content": ["neutral", "80"],
  "neutral-medium-content": ["neutral", "60"],
  "neutral-low-content": ["neutral", "40"],
  "neutral-xLow-content": ["neutral", "30"],
  "contentOn-neutral-high-surface": ["neutral", "20"],
  "magenta-high-content": ["magenta", "70"],
  "magenta-medium-content": ["magenta", "50"],
  "magenta-low-content": ["magenta", "40"],
  "magenta-xLow-content": ["magenta", "30"],
  "violet-high-content": ["violet", "70"],
  "violet-medium-content": ["violet", "50"],
  "violet-low-content": ["violet", "40"],
  "violet-xLow-content": ["violet", "30"],
  "blue-high-content": ["blue", "70"],
  "blue-medium-content": ["blue", "50"],
  "blue-low-content": ["blue", "40"],
  "blue-xLow-content": ["blue", "30"],
  "azure-high-content": ["azure", "70"],
  "azure-medium-content": ["azure", "50"],
  "azure-low-content": ["azure", "40"],
  "azure-xLow-content": ["azure", "30"],
  "cyan-high-content": ["cyan", "70"],
  "cyan-medium-content": ["cyan", "50"],
  "cyan-low-content": ["cyan", "40"],
  "cyan-xLow-content": ["cyan", "30"],
  "green-high-content": ["green", "70"],
  "green-medium-content": ["green", "50"],
  "green-low-content": ["green", "40"],
  "green-xLow-content": ["green", "30"],
  "chartreuse-high-content": ["chartreuse", "70"],
  "chartreuse-medium-content": ["chartreuse", "50"],
  "chartreuse-low-content": ["chartreuse", "40"],
  "chartreuse-xLow-content": ["chartreuse", "30"],
  "yellow-high-content": ["yellow", "70"],
  "yellow-medium-content": ["yellow", "50"],
  "yellow-low-content": ["yellow", "40"],
  "yellow-xLow-content": ["yellow", "30"],
  "orange-high-content": ["orange", "70"],
  "orange-medium-content": ["orange", "50"],
  "orange-low-content": ["orange", "40"],
  "orange-xLow-content": ["orange", "30"],
  "pink-high-content": ["pink", "70"],
  "pink-medium-content": ["pink", "50"],
  "pink-low-content": ["pink", "40"],
  "pink-xLow-content": ["pink", "30"],
  "magenta-utility": ["magenta", "60"],
  "violet-utility": ["violet", "60"],
  "blue-utility": ["blue", "60"],
  "azure-utility": ["azure", "60"],
  "cyan-utility": ["cyan", "60"],
  "green-utility": ["green", "60"],
  "chartreuse-utility": ["chartreuse", "60"],
  "yellow-utility": ["yellow", "60"],
  "orange-utility": ["orange", "60"],
  "pink-utility": ["pink", "60"],
  shadow: ["primary", "0"],
  "modal-overlay": ["neutral", "10"],
  white: ["neutral", "100"],
  logo: ["primary", "70"]
};
export {
  t as ACTIVE_OVERLAY_OPACITY,
  o as BACKGROUND_OVERLAY_OPACITY,
  w as DARK_THEME_ASSIGNMENTS,
  e as DISABLED_OPACITY,
  n as DISABLED_TEXT_OPACITY,
  s as FIXED_NEUTRAL_MONOCHROME_SEED_COLOR,
  g as FIXED_UTILITY_SEED_COLORS,
  c as FOREGROUND_VARIANT_TO_OVERLAY_OPACITY_MAP,
  a as FREE_VARIABLE_SEED_COLORS,
  m as GOSTUDENT_LEARNING_VARIABLE_SEED_COLORS,
  r as HOVER_OVERLAY_OPACITY,
  h as LIGHT_THEME_ASSIGNMENTS,
  l as NEUTRAL_SEED_COLOR_CHROMA,
  u as PLURALL_VARIABLE_SEED_COLORS,
  i as PREMIUM_VARIABLE_SEED_COLORS
};
